import { faTasks } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Grid from '@material-ui/core/Grid';
import React, { Component } from 'react';
import "../../../style";





class FeatureOne extends Component {
    render(){
        return(
            <Grid item sm={3} xs={12}>
                <div className="featureCard">
                    <div className="featureIcon">
                        <FontAwesomeIcon icon={faTasks} className="featureSvg"/>
                    </div>
                    <h3 className="CardHead">Record Agreements</h3>
                    <p className="cardDescription">
                    Input delivery contract
agreement details
while managing all
contracts in a single
platform                    </p>
            </div>
            </Grid>
        );
    }
}

export default FeatureOne;


// WEBPACK FOOTER //
// ./src/components/public/Home/FeatureOne.js